import { useMemo } from 'react';
import { useTranslation } from 'next-i18next/pages';
import { getListingFeatures } from '@pkgs/components/utils/listingDataUtils';
import { Chip } from '@pkgs/components';
import { type Listing } from '@pkgs/api/models';
import { Headline } from '@ev-tech/ui-core-components/Headline';

import { TRANSLATION_NAMESPACE } from '@/i18n/config';

import styles from './PropertyFeatures.module.css';

export const PropertyFeatures = ({ listing }: { listing: Listing }) => {
  const { t: tPropertyExpose } = useTranslation(TRANSLATION_NAMESPACE.property_expose);
  const { t: tListingData } = useTranslation(TRANSLATION_NAMESPACE.listing_data);
  const featuresToDisplay = useMemo(() => getListingFeatures(listing), [listing]);

  if (!featuresToDisplay.length) return null;

  return (
    <section className={styles.propertyFeatureContainer} data-testid="expose-property-features">
      <Headline size="h5" as="span" label={tPropertyExpose('search.expose.propertyDetails.label.features')} />
      <div className={styles.chipList}>
        {featuresToDisplay.map((feature) => (
          <Chip key={feature.fieldName} label={tListingData(feature.labelKey)} />
        ))}
      </div>
    </section>
  );
};
